import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { FETCH_OWNERSHIP_TYPE, GET_OWNERSHIP_TYPE, CREATE_OWNERSHIP_TYPE, UPDATE_OWNERSHIP_TYPE, DELETE_OWNERSHIP_TYPE } from 'actions/ownershipType';

function* fetchOwnershipType(action) {
  try {
    const response = yield call(API.getOwnershipType, action.payload);
    yield put({ type: FETCH_OWNERSHIP_TYPE.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: FETCH_OWNERSHIP_TYPE.FAIL, payload: { error: e } });
  }
}

function* getOwnershipTypeById(action) {
  try {
    const response = yield call(API.getOwnershipTypeById, action.payload);
    yield put({ type: GET_OWNERSHIP_TYPE.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_OWNERSHIP_TYPE.FAIL, payload: { error: e } });
  }
}

function* createOwnershipType(action) {
  try {
    const response = yield call(API.addOwnershipType, action.payload);
    yield put({ type: CREATE_OWNERSHIP_TYPE.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_OWNERSHIP_TYPE.FAIL, payload: { error: e } });
  }
}

function* updateOwnershipType(action) {
  try {
    const response = yield call(API.updateOwnershipType, action.payload);
    yield put({ type: UPDATE_OWNERSHIP_TYPE.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_OWNERSHIP_TYPE.FAIL, payload: { error: e } });
  }
}

function* deleteOwnershipType(action) {
  try {
    const response = yield call(API.deleteOwnershipType, action.payload);
    yield put({ type: DELETE_OWNERSHIP_TYPE.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_OWNERSHIP_TYPE.FAIL, payload: { error: e } });
  }
}

function* OwnershipType() {
  yield takeLatest(FETCH_OWNERSHIP_TYPE.REQUEST, fetchOwnershipType);
  yield takeLatest(GET_OWNERSHIP_TYPE.REQUEST, getOwnershipTypeById);
  yield takeLatest(CREATE_OWNERSHIP_TYPE.REQUEST, createOwnershipType);
  yield takeLatest(UPDATE_OWNERSHIP_TYPE.REQUEST, updateOwnershipType);
  yield takeLatest(DELETE_OWNERSHIP_TYPE.REQUEST, deleteOwnershipType);
}

export default OwnershipType;
